import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/components/views/Home.vue'
import Dashboard from '@/components/views/Dashboard.vue'
import Login from '@/components/views/Login.vue'
//ventas
import ListarVentas from '@/components/views/ventas/ListarVentas';
//reportes
import Index from '@/components/views/reportes/Index';
//comprobantes
import NuevoComprobante from '@/components/views/comprobantes/NuevoComprobante';
import NuevoRecibo from '@/components/views/comprobantes/NuevoRecibo';
import AnularComprobante from '@/components/views/comprobantes/AnularComprobante';
//articulos
import ListarArticulos from '@/components/views/articulos/ListarArticulos'
import NuevoArticulo from '@/components/views/articulos/NuevoArticulo'
import ActualizarStock from '@/components/views/articulos/ActualizarStock'
import AplicarAumento from '@/components/views/articulos/AplicarAumento'
import EditarArticulo from '@/components/views/articulos/EditarArticulo'
import VerArticulo from '@/components/views/articulos/VerArticulo'
import ActualizacionMasiva from '@/components/views/articulos/ActualizacionMasiva'
//pedidos
import NuevoPedido from '@/components/views/pedidos/NuevoPedido'
import VerPedido from '@/components/views/pedidos/VerPedido'
import EditarPedido from '@/components/views/pedidos/EditarPedido'
import ListarPedidos from '@/components/views/pedidos/ListarPedidos'
import HistorialPedidos from '@/components/views/pedidos/HistorialPedidos'
import ListarPedidosPendientes from '@/components/views/pedidos/ListarPedidosPendientes'
//marcas
import NuevaMarca from '@/components/views/marcas/NuevaMarca'
import ListarMarcas from '@/components/views/marcas/ListarMarcas'
import EditarMarca from '@/components/views/marcas/EditarMarca'
//familias
import NuevaFamilia from '@/components/views/familias/NuevaFamilia'
import ListarFamilias from '@/components/views/familias/ListarFamilias'
import EditarFamilia from '@/components/views/familias/EditarFamilia'
//listas
import ListarListas from '@/components/views/listas/ListarListas'
import EditarLista from '@/components/views/listas/EditarLista'
//clientes
import NuevoCliente from '@/components/views/clientes/NuevoCliente'
import EditarCliente from '@/components/views/clientes/EditarCliente'
import ListarClientes from '@/components/views/clientes/ListarClientes'
import VerCliente from '@/components/views/clientes/VerCliente'
import CuentasCorrientes from '@/components/views/clientes/CuentasCorrientes'
import AgregarSaldoAnterior from '@/components/views/clientes/AgregarSaldoAnterior'
//usuarios
import ListarUsuarios from '@/components/views/usuarios/ListarUsuarios'
import NuevoUsuario from '@/components/views/usuarios/NuevoUsuario'
import EditarUsuario from '@/components/views/usuarios/EditarUsuario'
//objetivos
import ListarObjetivos from '@/components/views/objetivos/ListarObjetivos'
import NuevoObjetivo from '@/components/views/objetivos/NuevoObjetivo'
import VerObjetivo from '@/components/views/objetivos/VerObjetivo'
//estadisticas
import EstadisticasPersonales from '@/components/views/estadisticas/EstadisticasPersonales'
import EstadisticasPorEmpleado from '@/components/views/estadisticas/EstadisticasPorEmpleado'
import EstadisticasGenerales from '@/components/views/estadisticas/EstadisticasGenerales'
import EstadisticasPorArticulo from '@/components/views/estadisticas/EstadisticasPorArticulo'
import VentasPorArticulo from '@/components/views/estadisticas/VentasPorArticulo'
import VentasArticuloFecha from '@/components/views/estadisticas/VentasArticuloFecha'
import AumentoGeneral from "@/components/views/articulos/AumentoGeneral.vue";

Vue.use(VueRouter)

const rutasObjetivos = [
  {
    path: '/objetivos/listar',
    name: 'ListarObjetivos',
    component: ListarObjetivos
  },
  {
    path: '/objetivos/nuevo',
    name: 'NuevoObjetivo',
    component: NuevoObjetivo
  },
  {
    path: '/objetivos/ver/:id',
    name: 'VerObjetivo',
    component: VerObjetivo
  },
]

const rutasEstadisticas = [
  {
    path: '/estadisticas/personales',
    name: 'EstadisticasPersonales',
    component: EstadisticasPersonales
  },
  {
    path: '/estadisticas/por-empleado',
    name: 'EstadisticasPorEmpleado',
    component: EstadisticasPorEmpleado
  },
  {
    path: '/estadisticas/generales',
    name: 'EstadisticasGenerales',
    component: EstadisticasGenerales
  },
  {
    path: '/estadisticas/por-articulo',
    name: 'EstadisticasPorArticulo',
    component: EstadisticasPorArticulo
  },
  {
    path: '/estadisticas/ventas-articulo',
    name: 'VentasPorArticulo',
    component: VentasPorArticulo
  },
  {
    path: '/estadisticas/ventas-articulo-fecha/:id/:descripcion/:desde/:hasta',
    name: 'VentasArticuloFecha',
    component: VentasArticuloFecha
  },
]

const rutasVentas = [
  {
    path: '/ventas/listar',
    name: 'ListarVentas',
    component: ListarVentas
  },
  {
    path: '/comprobantes/nuevo/:pedido_id?',
    name: 'NuevoComprobante',
    component: NuevoComprobante
  },
  {
    path: '/recibo/nuevo',
    name: 'NuevoRecibo',
    component: NuevoRecibo
  },
  {
    path: '/ventas/anular',
    name: 'AnularComprobante',
    component: AnularComprobante
  }
]

const rutasPedidos = [
  {
    path: '/pedidos/ver/:id',
    name: 'VerPedido',
    component: VerPedido
  },
  {
    path: '/pedidos/editar/:id',
    name: 'EditarPedido',
    component: EditarPedido
  },
  {
    path: '/pedidos/create',
    name: 'NuevoPedido',
    component: NuevoPedido
  },
  {
    path: '/pedidos/listar',
    name: 'ListarPedidos',
    component: ListarPedidos,

  },
  {
    path: '/pedidos/listar/pendientes',
    name: 'ListarPedidosPendientes',
    component: ListarPedidosPendientes,

  },
  {
    path: '/pedidos/historial',
    name: 'HistorialPedidos',
    component: HistorialPedidos,

  }
]

const rutasArticulos = [
  {
    path: '/articulos/listar',
    name: 'ListarArticulos',
    component: ListarArticulos
  },
  {
    path: '/articulos/crear',
    name: 'NuevoArticulo',
    component: NuevoArticulo
  },
  {
    path: '/articulos/editar/:id',
    name: 'EditarArticulo',
    component: EditarArticulo
  },
  {
    path: '/articulos/actualizar-stock',
    name: 'ActualizarStock',
    component: ActualizarStock
  },
  {
    path: '/articulos/aplicar-aumento',
    name: 'AplicarAumento',
    component: AplicarAumento
  },
  {
    path: '/articulos/ver/:id',
    name: 'VerArticulo',
    component: VerArticulo
  },
  {
    path: '/articulos/aumento-general',
    name: 'AumentoGeneral',
    component: AumentoGeneral
  },
  {
    path: '/articulos/actualizacion-masiva',
    name: 'ActualizacionMasiva',
    component: ActualizacionMasiva
  }
]

const rutasClientes = [
  {
    path: '/clientes/listar',
    name: 'ListarClientes',
    component: ListarClientes
  },
  {
    path: '/clientes/crear',
    name: 'NuevoCliente',
    component: NuevoCliente
  },
  {
    path: '/clientes/editar/:id',
    name: 'EditarCliente',
    component: EditarCliente
  },
  {
    path: '/clientes/ver/:id',
    name: 'VerCliente',
    component: VerCliente
  },
  {
    path: '/clientes/cuenta-corriente',
    name: 'CuentasCorrientes',
    component: CuentasCorrientes
  },
  {
    path: '/clientes/agregar-saldo',
    name: 'AgregarSaldoAnterior',
    component: AgregarSaldoAnterior
  },
]

const rutasFamilias = [
  {
    path: '/familias/listar',
    name: 'ListarFamilias',
    component: ListarFamilias
  },
  {
    path: '/familias/crear',
    name: 'NuevaFamilia',
    component: NuevaFamilia
  },
  {
    path: '/familias/editar/:id',
    name: 'EditarFamilia',
    component: EditarFamilia
  },
]
const rutasListas = [
  {
    path: '/listas/listar',
    name: 'ListarListas',
    component: ListarListas
  },
  {
    path: '/listas/editar/:id',
    name: 'EditarLista',
    component: EditarLista
  },
]

const rutasMarcas = [
  {
    path: '/marcas/listar',
    name: 'ListarMarcas',
    component: ListarMarcas
  },
  {
    path: '/marcas/crear',
    name: 'NuevaMarca',
    component: NuevaMarca
  },
  {
    path: '/marcas/editar/:id',
    name: 'EditarMarca',
    component: EditarMarca
  },
]

const rutasUsuarios = [
  {
    path: '/usuarios/listar',
    name: 'ListarUsuarios',
    component: ListarUsuarios
  },
  {
    path: '/usuarios/crear',
    name: 'NuevoUsuario',
    component: NuevoUsuario
  },
  {
    path: '/usuarios/editar/:id',
    name: 'EditarUsuario',
    component: EditarUsuario
  }
]


const routes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/reportes',
    name: 'Reportes',
    component: Index
  },
  {
    path: '/logout',
    name: 'Logout'
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  ...rutasPedidos,
  ...rutasMarcas,
  ...rutasFamilias,
  ...rutasClientes,
  ...rutasArticulos,
  ...rutasUsuarios,
  ...rutasVentas,
  ...rutasEstadisticas,
  ...rutasObjetivos,
  ...rutasListas,
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  linkExactActiveClass: "mm-active",
})

export default router
